import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FAQ } from '../models/Faq';

@Injectable({
  providedIn: 'root'
})
export class FaqService {


constructor(private readonly httpClient:HttpClient) {
 }

 getFAQ(lang : string): Observable<Array<FAQ>> {
  return this.httpClient.get<Array<FAQ>>(environment.api_url+'FAQ?lang='+lang);
}


}
